var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice-class-edit-form"},[_c('voice-class-base-form',{attrs:{"initial-data":_vm.voiceClass,"is-edit":""},on:{"submit":_vm.saveVoiceClass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }